<template>
  <div class="TopBar DarkNavigationBar">
    <div v-if="!isGuest" class="ButtonGroup">
      <a href="/">&larr; Back</a>
    </div>

    <div v-if="isDemo" class="ButtonGroup">
      <a class="MenuButton" href="/whiteboards/new_guest"
        >Make a whiteboard that saves</a
      >
    </div>

    <div class="ButtonGroup" v-if="!isDemo">
      <div class="BoardName" v-on:click="openBoardMetadataModal">
        <div>
          <span v-if="state.whiteboard.isTemplate">📘 </span>
          {{ state.whiteboard.name }}
        </div>
        <Countdown v-if="hasCountdown"></Countdown>
      </div>
    </div>

    <div class="ButtonGroup">
      <div class="BoardName">
        <a target="_blank" href="https://qapla.pro">Qapla Software Development</a>
      </div>
    </div>

    <div class="ButtonGroup">
      <a
        v-if="state.featureFlags.websocket_server && isGuest"
        v-on:click="editname"
      >
        {{ state.user.username }}
      </a>

      <TwoStateIconButton
        :value="isFullscreen"
        :onClick="toggleFullscreen"
        classExtra="DesktopOnly"
        iconFalse="expand-outline-white"
        iconTrue="contract-outline-white"
      >
      </TwoStateIconButton>

      <button class="MenuButton" v-on:click="openBoardMetadataModal">
        <img class="m-full-size" :src="'/img/icons/cog-outline-white.svg'" />
      </button>

      <LockButton
        v-if="isOwner"
        :value="state.isLocked"
        :onClick="toggleLocked"
      >
      </LockButton>

      <button class="MenuButton" v-on:click="downloadImage">
        Download image
      </button>

      <button
        v-on:click="openShareModal"
        v-if="state.featureFlags.share_prompt"
        class="MenuButton ShareButton"
      >
        Share
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Emit } from "vue-property-decorator";

import { ModalType } from "@/store/ModalType";
import Countdown from "@/components/Countdown.vue";
import LockButton from "@/components/LockButton.vue";
import TwoStateIconButton from "@/components/TwoStateIconButton.vue";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Countdown, TwoStateIconButton, LockButton } })
export default class TopBar extends WBComponent {
  isFullscreen = false;
  hasCountdown = false;

  mounted() {
    this.isFullscreen = document.fullscreenElement != null;
    this.hasCountdown = this.state.whiteboard.datetimeExpire !== null;
  }

  toggleFullscreen() {
    if (document.fullscreenElement === null) {
      document.body.requestFullscreen();
      this.isFullscreen = true;
    } else {
      document.exitFullscreen();
      this.isFullscreen = false;
    }
  }

  downloadImage() {
    ModalMutations.openModal(this.$store.commit, ModalType.ImageExport);
  }

  get isGuest(): boolean {
    return (window as Window).wbconfig?.session?.is_guest;
  }

  get isOwner(): boolean {
    return this.state.key.accessLevel === "admin";
  }

  get isDemo(): boolean {
    return this.$store.getters.isDemo;
  }

  @Emit()
  editname(e: MouseEvent) {
    e.preventDefault();
  }

  openBoardMetadataModal() {
    if (this.hasCountdown) {
      ModalMutations.openModal(this.$store.commit, ModalType.Expiration);
    } else if (this.state.user.session.is_guest) {
      alert("Only the board owner can edit the board’s name.");
    } else {
      ModalMutations.openModal(this.$store.commit, ModalType.EditBoardMetadata);
    }
  }

  openShareModal() {
    if (this.$store.getters.isDemo) {
      ModalMutations.openModal(this.$store.commit, ModalType.DemoNote);
    } else {
      ModalMutations.openModal(this.$store.commit, ModalType.Share);
    }
  }

  toggleLocked() {
    this.wbcontroller?.requestSetIsLocked(!this.state.isLocked);
  }
}
</script>

<style lang="scss">
.DarkNavigationBar {
  width: 100%;
  background-color: var(--bg-dark);
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 var(--margin-tiny);

  .ButtonGroup {
    height: 50px;
  }

  .ButtonGroup > a,
  .ButtonGroup > a:hover,
  .ButtonGroup > a:visited {
    color: var(--bg-light);
    cursor: pointer;
  }
}

.TopBar {
  .BoardName {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    color: var(--text-dark-hint);
    cursor: pointer;

    &:hover {
      background-color: var(--bg-dark-highlight-overlay);
    }
  }

  .BareIconButton {
    padding: 5px;
    width: 2rem;
    height: 2rem;
    background-color: transparent;
    border: none;

    &:hover {
      box-sizing: border-box;
      background-color: var(--bg-dark-2);
    }

    img {
      max-width: 100%;
    }
  }

  .MenuButton {
    line-height: normal;
    white-space: nowrap;
    position: relative;
    padding: 3px 4px 1px 4px;
    height: 30px;
    color: var(--text-light);
    cursor: pointer;
    border: 1px solid var(--text-light);
    border-radius: var(--border-radius-small);
    background-color: transparent;
    text-decoration: none;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    img {
      width: 14px;
      max-height: 22px;
      height: auto;
      transform: translateY(-1px);

      // assumes left side
      margin-right: 2px;

      &.m-full-size {
        width: 22px;
        margin: 0 var(--margin-tiny);
      }
    }

    &:hover {
      background-color: var(--bg-dark-2);
    }
  }
}
</style>
